import { FieldPolicy, TypePolicy } from '@apollo/client'
import { ManufacturerProductPropertyOptionDetail } from '@deltek/specification-client/core/Models/product'

export const propertyTypePolicy = {
    ManufacturerProductPropertyDetail: {
        keyFields: ['propertyId'],
    } as TypePolicy,
}
export const optionDetailsTypePolicy = {
    ManufacturerProductPropertyOptionDetail: {
        keyFields: ['optionId'],
    } as TypePolicy,
}

export const optionDetailsFieldPolicy = {
    properties: {
        options: {
            merge(
                existing = {},
                incoming: ManufacturerProductPropertyOptionDetail
            ) {
                return { ...existing, ...incoming }
            },
        },
    } as FieldPolicy,
}
